import { Flex, Text } from '@chakra-ui/react';

type Props = {
  label: string,
  value?: string | number | null,
  mb?: number,
};

export const InfoCol = ({
  label, value, mb = 2,
}: Props) => (
  <Flex gap={1} mb={mb} flexDirection="column">
    <Text fontSize="sm" color="text.muted" fontWeight={600}>{label}</Text>
    <Text fontSize="md">{value || 'Não informado'}</Text>
  </Flex>
);
